<template>
  <div>
    <b-row>
      <b-col lg="12" md="6" sm="6">
        <!-- Nome -->
        <b-form-group :label="$t('geral.name') + ':'" label-for="input-name">
          <b-form-input id="name" type="text" v-model="model.name" />
          <span class="text-danger" v-if="modelstate['Name']">
            {{ "*" + modelstate["Name"][0] }}
          </span>
        </b-form-group>

        <!-- Tamanho -->
        <b-form-group :label="$t('geral.size') + ':'" label-for="input-size">
          <b-form-select v-model="model.size">
            <option
              v-for="size in optionSize"
              :value="size.value"
              :key="size.value"
            >
              {{ size.text }}
            </option>
          </b-form-select>
        </b-form-group>

        <!-- Marcas -->
        <brand-vehicle-dropdown-modal :brandVehicleId.sync="model.brandId" />
      </b-col>
    </b-row>

    <!-- {{ model }} -->
  </div>
</template>

<script>
export default {
  name: "VehicleModel",
  components: {
    "brand-vehicle-dropdown-modal": () =>
      import(
        "@/components_rms/System/BrandVehicle/BrandVehicleDropdownModal.vue"
      ),
  },
  props: {
    modelstate: Array,
    model: {
      type: Object,
      required: true,
      default: () => ({
        name: null,
        size: null,
        brandId: null,
      }),
    },
  },
  data() {
    return {
      optionSize: [
        { value: null, text: "Nenhum" },
        { value: 1, text: "Pequeno" },
        { value: 2, text: "Médio" },
        { value: 3, text: "Grande" },
      ],
    };
  },
};
</script>